import React from "react";
import { connect } from "react-redux";
import { Formik, Form, FormikProps } from "formik";
import * as Toastr from "toastr";
import * as yup from "yup";

import ContactInfo from "./ContactInfo";
import HolidayHour from "./HolidayHour";
import LocationInfo from "./LocationInfo";
import Requirements from "./Requirements";
import ShippingAddress from "./ShippingAddress";

import { update } from "../redux/actions/locationAction";

declare var window: any;

class Index extends React.Component<any, any> {
  state = null;

  constructor(props: any) {
    super(props);

    this.init();
  }

  init = () => {
    const { location, contacts, fields, holiday_hours, locationTypes, values } =
      this.props;
    const requirement = {};
    fields.forEach((field: any) => {
      requirement[field.id.toString()] = values.find(
        (value: any) => value.requirement_field_id === field.id,
      )?.value;
    });

    const data = {
      ...location,
      location_type_id: (
        locationTypes.find(({ id }: any) => id === location.location_type_id) ||
        locationTypes[0]
      )?.id,
      contact: contacts[0]?.id,
      contacts,
      holidayHour: holiday_hours[0]?.id,
      holidayHours: holiday_hours,
      requirement,
      ship: location.ship.toString(),
      shipping_country: "us",
    };

    this.state = { initialValues: data };
  };

  handleSubmit = ({ holidayHours, ...data }: any, formik: any) => {
    if (this.props.view_only) return;

    window.Pace.stop();
    const { locationId, update } = this.props;

    const btn: any = document.getElementById("location-form-submit");
    btn.disabled = true;

    let counter = 0;
    const intervalID = setInterval(() => {
      window.Pace.bar.progress = counter++;
      window.Pace.bar.render();
      if (counter === 100) clearInterval(intervalID);
    }, 40);

    return update(locationId, { holiday_hours: holidayHours, ...data })
      .then(({ result }: any) => {
        const initialValues = { ...data, ...result, holidayHours };
        this.setState({ initialValues }, () => {
          formik.resetForm(initialValues);
        });

        Toastr.success("Data saved");
      })
      .catch((error: any) => {
        if (error.fields) {
          Toastr.error("Data didn't save!");
          if (error.fields.name) {
            const { takenNames = [] } = this.state;
            const name = data.name.toLowerCase();
            if (takenNames.indexOf(name) === -1) takenNames.push(name);
            this.setState({ takenNames: [...takenNames] });
          }
          formik.setErrors(error.fields);
        }
      })
      .finally(() => {
        btn.disabled = false;
        window.Pace.bar.progress = 100;
        window.Pace.bar.render();
        clearInterval(intervalID);
        setTimeout(window.Pace.stop, 500);
      });
  };

  validationSchema = () => {
    const { takenNames = [] } = this.state;
    return yup.object().shape({
      name: yup
        .string()
        .lowercase()
        .required(" ")
        .nullable()
        .notOneOf(takenNames, "Already taken!"),
      contacts: yup.array().of(
        yup.object().shape({
          email: yup.string().email(" "),
        }),
      ),
    });
  };

  render() {
    const { view_only } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={this.state.initialValues}
        validationSchema={this.validationSchema()}
        onSubmit={this.handleSubmit}
      >
        {(formik: FormikProps<any>) => (
          <Form id="location-form">
            <article className="col-xs-12 col-sm-6 col-md-3 sortable-grid ui-sortable">
              <LocationInfo formik={formik} viewOnly={view_only} />
              <ContactInfo formik={formik} viewOnly={view_only} />
            </article>
            <article className="col-xs-12 col-sm-6 sortable-grid ui-sortable">
              <ShippingAddress formik={formik} viewOnly={view_only} />
              <Requirements formik={formik} viewOnly={view_only} />
            </article>
            <article className="col-xs-12 col-sm-6 col-md-3 sortable-grid ui-sortable">
              <HolidayHour formik={formik} viewOnly={view_only} />
            </article>
          </Form>
        )}
      </Formik>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  locationId: state.location.data?.id,
  locationTypes: state.locationTypes.data,
  fields: state.fields.data,
  values: state.values.data,
});

const mapDispatchToProps = { update };

export default connect(mapStateToProps, mapDispatchToProps)(Index);
